import {FormControl, MenuItem, Select, InputLabel} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {SelectChangeEvent} from '@mui/material';

interface PaidFilterProps {
  onPaidChange: (event: SelectChangeEvent<string>) => void;
  currentPaidValue?: boolean | null;
}

const PaidFilter: React.FC<PaidFilterProps> = ({
  onPaidChange,
  currentPaidValue = null
}) => {
  const {t} = useTranslation();

  const value =
    currentPaidValue === null ? 'all' : currentPaidValue ? 'paid' : 'free';

  return (
    <FormControl fullWidth>
      <InputLabel id="paid-events-label" shrink>
        {t('payment_type')}
      </InputLabel>
      <Select
        labelId="paid-events-label"
        label={t('payment_type')}
        value={value}
        onChange={onPaidChange}
      >
        <MenuItem value="all">{t('all_events')}</MenuItem>
        <MenuItem value="paid">{t('paid_events')}</MenuItem>
        <MenuItem value="free">{t('free_events')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PaidFilter;
